
export default function RealInheritanceStories() {
  const stories = [
    {
      title: "The Johnson Family: Three Siblings, Three States",
      location: "Cleveland, OH",
      property: "16-unit apartment building",
      challenge:
        "Three siblings inherited their father's property. One lived in California, one in Florida, one in Ohio. None wanted to be landlords. Property needed $80,000 in deferred maintenance.",
      solution:
        "We provided a fair cash offer that all three siblings agreed on. Closed in 21 days after probate approval. No repairs needed.",
      outcome:
        "Each sibling received $187,000. Avoided 18 months of carrying costs ($136,800) and family conflict.",
      image:
        "https://public.readdy.ai/ai/img_res/60320a1c24a00b17d33f89b016867238.jpg",
    },
    {
      title: "Maria's Unexpected Inheritance",
      location: "Detroit, MI",
      property: "8-unit apartment complex",
      challenge:
        "Maria inherited her aunt's building while living 1,200 miles away. She had a full-time job, two kids, and no property management experience. Building had tenant issues and code violations.",
      solution:
        "We bought the property AS IS with all tenants in place. Handled all legal coordination with her probate attorney remotely.",
      outcome:
        "Maria closed in 28 days, received $340,000, and avoided the stress of long-distance property management.",
      image:
        "https://readdy.ai/api/search-image?query=Professional%20Hispanic%20woman%20business%20owner%20reviewing%20successful%20real%20estate%20documents%20with%20relief%20and%20happiness%20in%20modern%20office%20setting%20representing%20inherited%20property%20sale%20resolution%20and%20financial%20freedom&width=700&height=500&seq=inherited-story-006&orientation=landscape",
    },
    {
      title: "The Martinez Estate: Probate Complications",
      location: "Milwaukee, WI",
      property: "24-unit apartment building",
      challenge:
        "Estate had multiple creditor claims, unclear title issues, and five heirs with different financial needs. Property was losing $4,000/month due to vacancies and deferred maintenance.",
      solution:
        "We worked with the estate attorney to resolve title issues and provided a cash offer that satisfied all creditors and heirs.",
      outcome:
        "Closed 45 days after court approval. Heirs split $890,000 after debts. Stopped monthly losses immediately.",
      image:
        "https://readdy.ai/api/search-image?query=Professional%20estate%20attorney%20and%20diverse%20family%20group%20celebrating%20successful%20probate%20resolution%20with%20signed%20documents%20in%20elegant%20law%20office%20representing%20complex%20inherited%20property%20settlement%20and%20family%20harmony&width=700&height=500&seq=inherited-story-007&orientation=landscape",
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Real Stories from Families We've Helped
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Every inherited property situation is unique. Here are three real examples of how
            we've helped families navigate complex inheritance sales.
          </p>
        </div>

        <div className="space-y-12">
          {stories.map((story, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-xl overflow-hidden">
              <div className="grid lg:grid-cols-2 gap-0">
                <div className="relative h-80 lg:h-auto">
                  <img src={story.image} alt={story.title} className="w-full h-full object-cover" />
                  <div className="absolute top-6 left-6 bg-teal-500 text-white px-4 py-2 rounded-lg font-semibold">
                    {story.location}
                  </div>
                </div>
                <div className="p-10">
                  <h3 className="text-3xl font-bold mb-4 text-gray-900">{story.title}</h3>
                  <div className="mb-6">
                    <span className="inline-block bg-gray-100 text-gray-700 px-4 py-2 rounded-full text-sm font-semibold">
                      {story.property}
                    </span>
                  </div>

                  <div className="space-y-6">
                    <div>
                      <h4 className="text-lg font-bold text-gray-900 mb-2 flex items-center gap-2">
                        <i className="ri-error-warning-line text-red-500"></i>
                        The Challenge
                      </h4>
                      <p className="text-gray-700 leading-relaxed">{story.challenge}</p>
                    </div>

                    <div>
                      <h4 className="text-lg font-bold text-gray-900 mb-2 flex items-center gap-2">
                        <i className="ri-lightbulb-line text-teal-500"></i>
                        Our Solution
                      </h4>
                      <p className="text-gray-700 leading-relaxed">{story.solution}</p>
                    </div>

                    <div className="bg-teal-50 rounded-xl p-6">
                      <h4 className="text-lg font-bold text-gray-900 mb-2 flex items-center gap-2">
                        <i className="ri-checkbox-circle-line text-teal-600"></i>
                        The Outcome
                      </h4>
                      <p className="text-gray-800 leading-relaxed font-semibold">{story.outcome}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-2xl p-10 text-white text-center">
          <h3 className="text-3xl font-bold mb-4">Your Story Could Be Next</h3>
          <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
            We've helped over 500 families successfully sell inherited apartment buildings. No matter how
            complex your situation, we have the experience and resources to help you achieve a fair,
            fast outcome.
          </p>
          <a
            href="#contact"
            className="inline-block whitespace-nowrap bg-white text-teal-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
          >
            Share Your Situation
          </a>
        </div>
      </div>
    </section>
  );
}
